import md5 from "md5";
class Authorize {
	async login(parameter) {
		//复制参数
		let loginParameter = JSON.parse(JSON.stringify(parameter))
		loginParameter.password = md5(parameter.password)
		//微信环境
		if (window.__wxjs_environment === "miniprogram" ||
			window.navigator.userAgent
			.toLowerCase()
			.indexOf("micromessenger") > -1 ||
			window.navigator.wxuserAgent) {
			let session = localStorage.getItem("identity-session")
			if (session) {
				loginParameter.sessionId = session;
			}
		}

		let loginResult = await gApp.$command
			.execute({
				api: "/core-merch-api/sys/login",
				parameter: loginParameter,
			})
		this.loginSuccess(loginResult.data.identity);

	}
	async getWechatAuthrozeUrl(redirectPath) {
		let redirectUrl = `${location.origin}${redirectPath}`
		let res = await gApp.$command.execute({
			api: '/core-merch-api/wechat/GetWxAppid',
			parameter: {
				type: 'wx_public'
			}
		})

		//跳转公众号授权
		let url =
			`https://open.weixin.qq.com/connect/oauth2/authorize?appid=${
					res.data.appid
			}&redirect_uri=${
					encodeURIComponent(redirectUrl)
			}&response_type=code&scope=snsapi_base&state=STATE`;
		if (res.data.componentAppid) {
			url += '&component_appid=' + res.data.componentAppid
		}
		url += '#wechat_redirect';
		return url;
	}

	async loginWechat(wxAuthCode) {
		if (!wxAuthCode) {
			let url = await this.getWechatAuthrozeUrl('/login-weixin')
			location.replace(url);
			return;
		}
		try {
			//已绑定公众号，自动登录
			let result = await gApp.$command.execute({
				api: "/core-merch-api/wechat/loginWeixin",
				parameter: {
					code: wxAuthCode
				}
			})
			localStorage.setItem("identity-session", result.data.sessionId);
			this.loginSuccess(result.data.identity);
		} catch (ex) {
			//code == 100表示未绑定
			if (ex.code != 100) {
				if (confirm(ex.message + '，确认重试？')) {
					location.replace('/login-weixin');
				}
				return;
			}
			//openid未绑定账号
			//记录sessionid，跳转登录页面
			
			localStorage.setItem("identity-session", ex.data.sessionId);
			location.replace(`${location.origin}/login`);
		};
	}

	loginSuccess(token) {
		localStorage.setItem("identity", token);
		let gotoUrl = sessionStorage.getItem("goto-url");
		if (!gotoUrl) {
			gotoUrl = location.origin + gApp.config.BASE_URL;
		}
		sessionStorage.removeItem("goto-url");
		location.replace(gotoUrl);
	}
}

export default Authorize;